import React, { useEffect, useState } from "react";
import MUITable from "Components/UI/Tables/MUITable";
import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import LinkIcon from "@mui/icons-material/Link";

import cutStrAtAndAddDots from "utils/cutStrAtAndAddDots";
import {
  getParseStatusLabelById,
  getSystemStatusLabelById,
} from "utils/labels";
import {
  getSystemStatusColorByLabel,
  getParseStatusColorByLabel,
} from "utils/colors";
import CommonChip from "Components/UI/Tables/CommonChip";
import { CircularProgress } from "@mui/material";

const createTableRows = (files) => {
  return files?.map((i) => {
    return [
      i.Id,
      i.Name,
      i.ClientId,
      i.Category,
      i.IsCompleted ? "Klar" : "Ej klar",
      getParseStatusLabelById(i.ParseStatus),
      cutStrAtAndAddDots(i.ParseMessage, 45),
      getSystemStatusLabelById(i.SystemStatus),
      i.CreateTime,
    ];
  });
};

export default function FilesTable({ loading, files }) {
  const [rows, setRows] = useState(createTableRows(files));
  useEffect(() => {
    setRows(createTableRows(files));
  }, [files]);

  const columns = [
    {
      name: "",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRenderLite: (dataIndex) => {
          return (
            <IconButton
              component={Link}
              to={`${rows[dataIndex][0]}`}
              aria-label="edit"
              size="small"
            >
              <LinkIcon sx={{ p: 0, m: 0 }} />
            </IconButton>
          );
        },
      },
    },
    {
      name: "ID",
      options: {
        filter: false,
      },
    },
    {
      name: "Namn",
      options: {
        filter: false,
      },
    },
    {
      name: "Klient",
      options: {
        customBodyRender: (value) => {
          return value ? <Link to={`/clients/${value}`}>{value}</Link> : value;
        },
      },
    },
    { name: "Kategori" },
    {
      name: "Bearbetad",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return (
            <CommonChip
              labelName={value}
              color={value === "Ej klar" ? "error" : "success"}
            />
          );
        },
      },
    },
    {
      name: "Kontrollstatus",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return (
            <CommonChip
              labelName={value}
              color={getParseStatusColorByLabel(value)}
            />
          );
        },
      },
    },
    {
      name: "Kontrollmeddelande",
      options: {
        filter: false,
      },
    },
    {
      name: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <CommonChip
              labelName={value}
              color={getSystemStatusColorByLabel(value)}
            />
          );
        },
      },
    },
    {
      name: "Skapad",
      options: {
        filter: false,
      },
    },
  ];

  const options = {
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    downloadOptions: {
      separator: ";",
      filename: "all_files.csv",
    },
    textLabels: {
      body: {
        noMatch: loading ? <CircularProgress /> : "",
      },
    },
    rowsPerPage: 30,
    rowsPerPageOptions: [10, 30, 100],
    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },
  };

  return (
    <MUITable options={options} title={""} data={rows} columns={columns} />
  );
}
